import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PrefixSimplifiedType } from '../../interfaces/Prefix'
import { getStatus } from '../../../httpClient/Requests/Api/TEMPO/system'
import { LookupState } from '../../interfaces/LookupState'
import { Lookup } from '../../../httpClient/interfaces/Lookup'

export const initialState: LookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchStatus = (prefix: PrefixSimplifiedType) =>
    createAsyncThunk(`${prefix}/status/fetchStatus`, async () => {
        let status: Lookup[] = []
        if (prefix.includes('TEMPO')) {
            const response = await getStatus()
            status = response.data
        }
        return status
    })

const statusSlice = (prefix: PrefixSimplifiedType) =>
    createSlice({
        name: `${prefix}/status`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchStatus(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchStatus(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchStatus(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const status = (prefix: PrefixSimplifiedType) => statusSlice(prefix).reducer

export default status
